<script setup lang="ts">
import { useStore } from '~/store'

const store = useStore()
</script>

<template>
  <div class="ui toast-container">
    <message
      v-for="message in store.state.ui.messages"
      :key="message.key"
      :message="message"
      :class="$style.message"
    />
    <slot />
  </div>
</template>

<style module >
  .message {
    position: fixed;
    bottom: 65px;
    right: 0;
    top: auto;
  }
</style>
